import React from "react";
import { CircleCheck, Download, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TaXappFeatureShowcase() {
  const benefits = ["Gezielter Muskelaufbau", "Effektive Fettverbrennung", "Beckenbodentraining", "Nicht-invasive Behandlung"];
  return <section data-section-id="253034" id="emptreatmentfeature" className="overflow-hidden bg-muted ![padding:96px_0px_0px_0px] !h-[750px]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="relative mx-auto w-full max-w-4xl order-2 flex flex-col sm:flex-row gap-4 items-center justify-center">
            {}
            <div className="absolute inset-0 bg-accent/30 rounded-3xl transform rotate-3 scale-105 -z-10 transition-transform duration-300"></div>
            <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-071-scaled.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair_treatment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair_treatment.png-wvc-sizes" alt="EMP Chair Behandlung" className="rounded-lg shadow-xl h-auto object-cover transition-transform duration-300 w-full sm:w-1/2 hover:scale-105" loading="lazy" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair_device_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair_device_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair_device_detail.png-wvc-sizes" alt="EMP Chair Detail" className="rounded-lg shadow-xl object-cover transition-transform duration-300 w-full !h-[533px] sm:w-1/2 hover:scale-105" loading="lazy" src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-036-scaled.jpg" />
          </div>

          {}
          <div className="flex flex-col gap-8 order-1">
            
            {}
            <div className="flex items-start gap-5">
              
              <div className="flex flex-col gap-1.5">
                <h2 className="font-bold font-default !text-6xl !text-[rgba(112,174,192,1)]">So funktioniert EMP Chair Pro</h2>
                
                
              </div>
            </div>

            {}
            <p className="text-lg text-muted-foreground leading-relaxed font-default">Sie setzen sich vollständig bekleidet auf den EMP Chair Pro. In nur 28 Minuten erzeugt die HI-EMP Technologie über 12.000 Muskelkontraktionen in Ihrem Beckenboden. Stärker, als es durch eigene Anspannung jemals möglich wäre.<div><br /></div><div>Das Besondere: Die elektromagnetischen Wellen durchdringen alle 3 Muskelschichten gleichzeitig. So entsteht ein Trainingseffekt, den keine Übung der Welt erzielen kann. Ganz ohne Schmerzen, ohne Strom und ohne Eigenaufwand. Gleichzeitig lernt Ihr Gehirn, den Beckenboden wieder gezielt anzusteuern. Das bedeutet: Sie spüren Ihren Beckenboden nicht nur während der Anwendung, sondern gewinnen auch im Alltag die Kontrolle zurück.</div></p>

            {}
            
            

            {}
            <div className="flex flex-wrap items-center gap-4 pt-4">
              <Link to="/SolutionsSubpagesAdditionalTreatmentsPage">
                <Button size="lg" className="font-medium bg-primary inline-flex items-center justify-center whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 gap-2 text-base h-12 px-8 rounded-lg shadow-md transition-all duration-300 !bg-[rgba(82,165,183,1)] !font-extrabold disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 text-secondary">
                  <Download className="w-5 h-5" />
                  Termin vereinbaren
                </Button>
              </Link>
              <Link to="/SolutionsSubpagesPage">
                
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>;
}